export const authentication = {
    activeChangePasswordStrategy: true,
    displayGARHelper: false,
    displayLoginLogo: true,
    displayPartnersLogo: [
        {src: 'logo-edu-up.jpg', alt: 'edu-up', class: 'logo-edu-up'},
        {src: 'logo-menj-tricolore.png', alt: 'menj', class: 'logo-menj-tricolore'},
        {src: 'ocirp.jpg', alt: 'education-nationale', class: 'logo-ocirp'},
        ],
    enableFormLogin: true,
    enableGAR: true,
    enableSSO: false,
    firstConnexionRedirection: {
        trainer: '/groups/list/groups'
    },
    overrideDefaultRouteByRole: {
        learner: '/home',
        trainer: '/boussole',
    },
    licenceLink: 'https://www.catalogue.education/inclusive/'// lien vers formulaire licence
};